<script setup lang="ts">
import GeoCatalogPage from '~/components/pages/catalog/GeoCatalogPage.vue'
import CatalogPage from '~/components/pages/catalog/CatalogPage.vue'

definePageMeta({
    layout: 'catalog',
    name: 'master_category'
})

const route = useRoute()

enum CatalogModeEnum {
    geo = 'geo',
    list = 'list'
}

const getCatalogMode = () => {
    const mode = route.query?.mode
    const modeValue = Array.isArray(mode) ? mode[0] : mode
    return modeValue === CatalogModeEnum.geo ? CatalogModeEnum.geo : CatalogModeEnum.list
}

const catalogMode = ref(getCatalogMode())

watch(() => route.query?.mode, () => {
    catalogMode.value = getCatalogMode()
}, { immediate: false })

</script>

<template>
    <div class="">
        <template v-if="catalogMode === CatalogModeEnum.geo">
            <client-only>
                <GeoCatalogPage />
                <template #fallback>
                    <div></div>
                </template>
            </client-only>
        </template>
        <template v-else>
            <CatalogPage />
        </template>
    </div>
</template>